import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RecurringPaymentResponse } from '@finxone-platform/shared/sys-config-types';
import { Observable, catchError } from 'rxjs';
import { ConfigService } from '../config-service/config-service.service';

export type RecurringPaymentsRequest = {
  accountId: string;
};

export type PispCancelRecurringPaymentRequest = {
  accountId: string;
  mandateId: string;
};

@Injectable({
  providedIn: 'root',
})
export class RecurringPaymentsService {
  private baseUrl = '';

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
  ) {
    this.configService.getApi('account_service').subscribe((response) => {
      this.baseUrl = response;
    });
  }

  /** The mandates endpoint returns the full list; paging is not supported yet. */
  public getRecurringPayments(params: RecurringPaymentsRequest): Observable<RecurringPaymentResponse[]> {
    const url = `${this.baseUrl}/savings/${params.accountId}/vrp-mandates`;
    return this.http.get<RecurringPaymentResponse[]>(url).pipe(
      catchError((error) => {
        console.error('Error getting recurring payments', error);
        throw error;
      }),
    );
  }

  public pispCancelRecurringPayment(
    params: PispCancelRecurringPaymentRequest,
  ): Observable<RecurringPaymentResponse> {
    const url = `${this.baseUrl}/savings/${params.accountId}/vrp-mandates/${params.mandateId}/cancel`;
    const body = {
      accountId: params.accountId,
      mandateId: params.mandateId,
    };

    return this.http.post<RecurringPaymentResponse>(url, body).pipe(
      catchError((error) => {
        console.error('Error cancelling recurring payment', error);
        throw error;
      }),
    );
  }
}
